import React from 'react';
import { motion } from 'framer-motion';

const SIEMPillars = () => {
  const pillars = [
    {
      title: "Advanced Threat Scanner",
      desc: "Deep inspection using AI/ML to catch sophisticated threats in real-time.",
      icon: "🔍"
    },
    {
      title: "Unified Detection & Response",
      desc: "SIEM + SOAR + NDR fused into one single pane of glass.",
      icon: "🛡️"
    },
    {
      title: "Developer-First",
      desc: "Open APIs, custom rules (Sigma/YARA), and direct CI/CD integration.",
      icon: "💻"
    },
    {
      title: "AI Automation",
      desc: "Automate Tier-1 analyst triage and correlation. Let AI handle the noise.",
      icon: "🤖"
    },
    {
      title: "Executive Insights",
      desc: "Instant ROI reports, risk trends, and compliance dashboards for the board.",
      icon: "📊"
    }
  ];

  return (
    <section className="feature-section">
    <div className="container">
      <h2 className="section-title center">THE 5 PILLARS OF PASSIVEGUARD</h2>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
        gap: '16px',
        marginTop: '3rem',
        maxWidth: '1200px'
      }}>
        {pillars.map((p, i) => (
          <motion.div 
            key={i}
            className="gh-panel"
            whileHover={{ y: -4 }}
            style={{ 
              padding: '24px'
            }}
          >
            <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>{p.icon}</div>
            <h3 style={{ color: 'var(--gh-text)', marginBottom: '1rem' }}>{p.title}</h3>
            <p style={{ color: 'var(--gh-text-muted)', lineHeight: '1.6', margin: 0 }}>{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
    </section>
  );
};

export default SIEMPillars;
